import { request } from './apiClient';

// Autentica no backend (POST /api/auth/login) e guarda token/nome/email no localStorage.
export const login = async (email, senha) => {
  try {
    const data = await request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, senha }),
    });

    if (data && data.token) {
      localStorage.setItem('token', data.token);
      
      if (data.nome) localStorage.setItem('userNome', data.nome);
      if (data.email) localStorage.setItem('userEmail', data.email);
    }

    return data; 
  } catch (error) {
    console.error("Erro no serviço de login:", error);
    throw error; 
  }
};


// Pede ao backend um novo código de validação de e-mail (resposta sempre genérica).
export const enviarCodigoValidacao = (email) =>
  request('/api/auth/enviar-codigo-validacao', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });

// Valida o código de 6 dígitos recebido por e-mail e ativa o usuário.
export const validarCodigo = (email, codigo) =>
  request('/api/auth/validar-codigo', {
    method: 'POST',
    body: JSON.stringify({ email, codigo }),
  });
